import React, {useEffect, useState} from "react";
import {Button, Modal, Row, Spin, Form, notification, Steps, Icon} from "antd";
import {companyService, systemService} from "../../../services";
import LegalEntityFormFields from "./form-fields";
import {legalEntityService} from "../../../services/legal-entity.service";
import i18n from "i18next";

export default function ModalEditCompany({legalEntityID, countryId, isShow, setIsShow}) {
  const [loading, setLoading] = useState(false);
  const [legalEntityData, setLegalEntityData] = useState({});
  const [formFieldsValues, setFormFieldsValues] = useState({});
  const [fieldsErrors, setFieldsErrors] = useState({});

  let submitBtnStyle = {
    width: "200px",
    height: "43px",
    background: "#1CAA53",
    position: "static",
    borderRadius: "10px",
    color: "white",
    borderColor: "transparent",
  };

  useEffect(() => {
    if (isShow) {
      setLoading(true);

      companyService
        .getLegalEntityData(legalEntityID)
        .then((response) => {

          setLegalEntityData(response);
          let newData
          fields.map((item) => {
            const val = (response[item.key] === null || response[item.key] === undefined) ? '' : response[item.key];
            newData = {...newData, [item.key]: val}
          });
          setFormFieldsValues({...newData});

          setLoading(false);

        })
        .catch((error) => {
          notification.error({
            message: i18n.t('components.notification.titles.getLegalEntityData'),
            description: error,
          });
        });
    }
  }, [isShow]);

  function getBanks(bic, setBanksList) {
    systemService.getBanksList(bic)
      .then(data => {
        setBanksList(data);
      })
      .catch();
  }

  let editLegalEntity;

  let fields;
  const fieldsRus = [
    {key:"Name", title: i18n.t('modals.modalEditCompany.fields.name.title')},
    {key:"FullName", title: i18n.t('modals.modalEditCompany.fields.fullName.title')},
    {key:"FirstName", title: i18n.t('modals.modalEditCompany.fields.firstName.title')},
    {key:"Patronymic", title: i18n.t('modals.modalEditCompany.fields.patronymic.title')},
    {key:"SecondName", title: i18n.t('modals.modalEditCompany.fields.secondName.title')},
    {key:"Bic", title: i18n.t('modals.modalEditCompany.fields.bic.title')},
    {key:"Rs", title: i18n.t('modals.modalEditCompany.fields.rs.title')},
    {key:"RegAddress", title: i18n.t('modals.modalEditCompany.fields.address.title')},
    {key:"LegalAddress", title: i18n.t('modals.modalEditCompany.fields.legalAddress.title')},
    {key:"MailingAddress", title: i18n.t('modals.modalEditCompany.fields.mailingAddress.title')}
  ]
  const fieldsKaz = [
    {key:"Name", title: i18n.t('modals.modalEditCompany.fields.name.title')},
    {key:"FullName", title: i18n.t('modals.modalEditCompany.fields.fullName.title')},
    {key:"FirstName", title: i18n.t('modals.modalEditCompany.fields.firstName.title')},
    {key:"Patronymic", title: i18n.t('modals.modalEditCompany.fields.patronymic.title')},
    {key:"SecondName", title: i18n.t('modals.modalEditCompany.fields.secondName.title')},
    {key:"Bic", title: i18n.t('modals.modalEditCompany.fields.bic.title')},
    {key:"BankName", title: i18n.t('modals.modalEditCompany.fields.bankName.title')},
    {key:"Rs", title: i18n.t('modals.modalEditCompany.fields.rs.title')},
    {key:"RegAddressRegion", title: i18n.t('modals.modalEditCompany.fields.region.title')},
    {key:"RegAddressLocality", title: i18n.t('modals.modalEditCompany.fields.addressLocality.title')},
    {key:"RegAddressStreet", title: i18n.t('modals.modalEditCompany.fields.addressStreet.title')},
    {key:"RegAddressHouseNumber", title: i18n.t('modals.modalEditCompany.fields.addressHouseNumber.title')},
    {key:"RegAddressPremiseNumber", title: i18n.t('modals.modalEditCompany.fields.addressPremiseNumber.title')},
    {key:"RegAddressPostalCode", title: i18n.t('modals.modalEditCompany.fields.addressPostalCode.title')},
    {key:"LegalAddressRegion", title: i18n.t('modals.modalEditCompany.fields.region.title')},
    {key:"LegalAddressStreet", title: i18n.t('modals.modalEditCompany.fields.addressStreet.title')},
    {key:"LegalAddressLocality", title: i18n.t('modals.modalEditCompany.fields.addressLocality.title')},
    {key:"LegalAddressHouseNumber", title: i18n.t('modals.modalEditCompany.fields.addressHouseNumber.title')},
    {key:"LegalAddressPremiseNumber", title: i18n.t('modals.modalEditCompany.fields.addressPremiseNumber.title')},
    {key:"LegalAddressPostalCode", title: i18n.t('modals.modalEditCompany.fields.addressPostalCode.title')}
  ]
  const fieldsBel = [
    {key:"Name", title: i18n.t('modals.modalEditCompany.fields.name.title')},
    {key:"FullName", title: i18n.t('modals.modalEditCompany.fields.fullName.title')},
    {key:"FirstName", title: i18n.t('modals.modalEditCompany.fields.firstName.title')},
    {key:"Patronymic", title: i18n.t('modals.modalEditCompany.fields.patronymic.title')},
    {key:"SecondName", title: i18n.t('modals.modalEditCompany.fields.secondName.title')},
    {key:"Bic", title: i18n.t('modals.modalEditCompany.fields.bic.title')},
    {key:"BankName", title: i18n.t('modals.modalEditCompany.fields.bankName.title')},
    {key:"AccountNumber", title:  i18n.t('modals.modalEditCompany.fields.accountNumber.title')},
    {key:"AddressCity", title: i18n.t('modals.modalEditCompany.fields.addressCity.title')},
    {key:"Address", title: i18n.t('modals.modalEditCompany.fields.fullAddress.title')},
    {key:"MailingAddress", title: i18n.t('modals.modalEditCompany.fields.mailingAddress.title')}
  ]

  switch (countryId) {
    default:
    case 1:
      fields = fieldsRus;
      editLegalEntity = legalEntityService.editRusLegalEntityData;
      break;
    case 6:
      fields = fieldsKaz;
      editLegalEntity = legalEntityService.editKazLegalEntityData;
      break;
    case 3:
      fields = fieldsBel;
      editLegalEntity = legalEntityService.editBelLegalEntityData;
      break;
  }

  const submitHandler = () => {
    editLegalEntity(legalEntityID, formFieldsValues)
      .then(response => {
        if (response.code === 400) {
          notification.error({
            message: i18n.t('components.notification.titles.editLegalEntityData'),
            description: response.message,
          });
          setFieldsErrors(response.errors);
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.editLegalEntityData'),
            description: response.message,
          });

          setIsShow(false);
        }

        setLoading(false);
      })
      .catch(errMsg => {
        notification.error({
          message: i18n.t('components.notification.titles.editLegalEntityData'),
          description: errMsg,
        });

        setLoading(false);
      });
  }

  return (
    <Modal
      title={i18n.t('modals.modalEditCompany.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={
        <div style={{marginTop: "10"}}>
          <Button htmlType="submit" key="submit" style={submitBtnStyle} onClick={() => submitHandler()} type="primary">
            {i18n.t('main.buttons.save')}
          </Button>
        </div>
      }
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Form>
          <Row gutter={[16, 24]}>
            <LegalEntityFormFields
              data={legalEntityData}
              setFormFieldsValues={setFormFieldsValues}
              formFieldsValues={formFieldsValues}
              fields={fields}
              fieldsErrors={fieldsErrors}
            />
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
}
